import React, { useState, useEffect } from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import { useInView } from 'react-intersection-observer'

const NUM_SPARKLES = window.innerWidth <= 768 ? 15 : 25;
const getRandom = (min: number, max: number) => Math.random() * (max - min) + min;

interface FamilyBusinessProps {
  onApplyClick: () => void
}

const FamilyBusiness: React.FC<FamilyBusinessProps> = ({ onApplyClick: _onApplyClick }) => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  })

  const [selectedVideo, setSelectedVideo] = useState<string | null>(null)
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [videoThumbnails, setVideoThumbnails] = useState<{[key: string]: string}>({})

  // Данные для видео (локальные файлы)
  const videos = [
    {
      id: 2,
      title: "Автомойка №1", 
      description: "Видео об автомойке",
      thumbnail: "/content/balance.png", // Замените на реальное превью
      videoUrl: "/content/Video/CarWashReady (1).mp4" // Реальный файл автомойки
    }
  ]

  const openModal = (videoUrl: string) => {
    setSelectedVideo(videoUrl)
    setIsModalOpen(true)
  }

  const closeModal = () => {
    setIsModalOpen(false)
    setSelectedVideo(null)
  }

  // Функция для генерации превью из видео
  const generateVideoThumbnail = (videoUrl: string, videoId: number) => {
    const video = document.createElement('video')
    video.crossOrigin = 'anonymous'
    video.src = videoUrl
    video.muted = true
    video.currentTime = 0.1 // Устанавливаем время на 0.1 секунды для получения кадра
    
    video.addEventListener('loadeddata', () => {
      const canvas = document.createElement('canvas')
      const ctx = canvas.getContext('2d')
      if (ctx) {
        canvas.width = video.videoWidth
        canvas.height = video.videoHeight
        ctx.drawImage(video, 0, 0, canvas.width, canvas.height)
        
        const thumbnailUrl = canvas.toDataURL('image/jpeg', 0.8)
        setVideoThumbnails(prev => ({
          ...prev,
          [videoId]: thumbnailUrl
        }))
      }
    })
    
    video.load()
  }

  // Генерация превью для видео при загрузке компонента
  useEffect(() => {
    videos.forEach(video => {
      generateVideoThumbnail(video.videoUrl, video.id)
    })
  }, [])

  // Закрытие модального окна по клику вне его
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        closeModal()
      }
    }

    if (isModalOpen) {
      document.addEventListener('keydown', handleEscape)
      document.body.style.overflow = 'hidden'
    }

    return () => {
      document.removeEventListener('keydown', handleEscape)
      document.body.style.overflow = 'unset'
    }
  }, [isModalOpen])

  return (
              <section id="family-business" className="h-[150px] sm:h-[180px] md:h-[200px] relative overflow-hidden">
       {/* Gradient Background */}
       <div className="absolute inset-0 bg-gradient-to-br from-dark-900 via-dark-800 to-primary-900/20"></div>
       
       {/* Sparkles */}
       <div className="absolute inset-0 pointer-events-none overflow-hidden">
         {Array.from({ length: NUM_SPARKLES }).map((_, i) => {
           const left = getRandom(5, 95);
           const top = getRandom(5, 95);
           const xMove = getRandom(-80, 80);
           const yMove = getRandom(-80, 80);
           const duration = getRandom(12, 24);
           const delay = getRandom(0, 3);
           const size = window.innerWidth <= 768 ? getRandom(0.2, 1.2) : getRandom(0.3, 1.8);
           const opacity = window.innerWidth <= 768 ? getRandom(0.1, 0.3) : getRandom(0.2, 0.4);
           
           const sparkleColors = [
             'bg-primary-400',
             'bg-pink-400',
             'bg-purple-400',
             'bg-blue-400',
             'bg-cyan-400',
             'bg-white',
             'bg-primary-300',
             'bg-pink-300',
           ];
           const color = sparkleColors[Math.floor(Math.random() * sparkleColors.length)];
           
           return (
             <motion.div
               key={i}
               className={`absolute ${color} rounded-full`}
               style={{
                 left: `${left}%`,
                 top: `${top}%`,
                 width: `${size * 0.4}rem`,
                 height: `${size * 0.4}rem`,
                 opacity,
               }}
               animate={{
                 x: [0, xMove, 0],
                 y: [0, yMove, 0],
               }}
               transition={{
                 duration,
                 repeat: Infinity,
                 delay,
               }}
             />
           );
         })}
       </div>

      <div className="relative z-10 w-full">
        {/* Header */}
                 {/* Main Content */}
         <div className="max-w-6xl mx-auto px-4 h-full relative">
                                                                                               <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 w-full" style={{ marginBottom: window.innerWidth <= 768 ? '-120px' : '-160px', marginLeft: window.innerWidth <= 768 ? '10px' : '50px' }}>
                     <motion.div
             ref={ref}
             initial={{ opacity: 0, y: 50 }}
             animate={inView ? { opacity: 1, y: 0 } : {}}
             transition={{ delay: 0.5, duration: 0.8 }}
                           className="flex flex-col lg:flex-row items-center gap-2 sm:gap-4 w-full"
           >
                         {/* Left side - Text */}
                           <div className="flex flex-col lg:flex-row items-center gap-3 sm:gap-6 lg:w-1/4">
               {/* Text */}
               <div className="text-center lg:text-left">
                                 <h3 className="text-lg sm:text-xl md:text-2xl font-bold text-white mb-2 sm:mb-3">
                  Бизнесы семьи
                </h3>
                                 <p className="text-gray-300 text-sm sm:text-base leading-relaxed max-w-md">

                </p>
              </div>
            </div>

                                                   {/* Right side - Video previews */}
                           <div className="lg:w-1/2 flex justify-center">
               {videos.map((video, index) => (
                 <motion.div
                   key={video.id}
                   initial={{ opacity: 0, scale: 0.9 }}
                   animate={inView ? { opacity: 1, scale: 1 } : {}}
                   transition={{ delay: 0.7 + index * 0.2, duration: 0.6 }}
                   className={`group cursor-pointer ${index === 0 ? 'mr-2 sm:mr-4 md:mr-8' : 'ml-2 sm:ml-4 md:ml-8'}`}
                   onClick={() => openModal(video.videoUrl)}
                 >
                  {/* Video preview frame */}
                  <div className="relative overflow-hidden rounded-xl sm:rounded-2xl border-2 border-gray-700/50 hover:border-primary-500/50 transition-all duration-300 bg-gray-900/50 backdrop-blur-sm">
                                         {/* Thumbnail */}
                     <div className="aspect-video relative overflow-hidden w-32 sm:w-40 md:w-48 lg:w-56">
                       <img 
                         src={videoThumbnails[video.id] || video.thumbnail} 
                         alt={video.title}
                         className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                       />
                      
                                             {/* Play button overlay */}
                       <div className="absolute inset-0 bg-black/30 group-hover:bg-black/20 transition-colors duration-300 flex items-center justify-center">
                         <div className="w-8 h-8 sm:w-10 sm:h-10 md:w-12 md:h-12 bg-primary-500/80 group-hover:bg-primary-400 rounded-full flex items-center justify-center group-hover:scale-110 transition-all duration-300">
                           <svg 
                             className="w-4 h-4 sm:w-5 sm:h-5 md:w-6 md:h-6 text-white ml-0.5 sm:ml-1" 
                             fill="currentColor" 
                             viewBox="0 0 24 24"
                           >
                             <path d="M8 5v14l11-7z"/>
                           </svg>
                         </div>
                       </div>
                    </div>
                    
                                         
                  </div>
                </motion.div>
              ))}
              
                             {/* Text labels for videos */}
               <div className="flex flex-col justify-center ml-4 sm:ml-8 md:ml-16 space-y-2 sm:space-y-4">
                 <motion.div
                   initial={{ opacity: 0, x: 20 }}
                   animate={inView ? { opacity: 1, x: 0 } : {}}
                   transition={{ delay: 0.9, duration: 0.6 }}
                   className="text-left"
                 >
                                       <h4 className="text-sm sm:text-base md:text-lg font-bold text-white">
                      АЗС №2
                    </h4>
                 </motion.div>
                 <motion.div
                   initial={{ opacity: 0, x: 20 }}
                   animate={inView ? { opacity: 1, x: 0 } : {}}
                   transition={{ delay: 1.1, duration: 0.6 }}
                   className="text-left"
                 >
                                                                             <h4 className="text-sm sm:text-base md:text-lg font-bold text-white whitespace-nowrap">
                       Автомойка №1
                     </h4>
                 </motion.div>
               </div>
            </div>
                     </motion.div>
           </div>
         </div>
      </div>

      {/* Modal for video playback */}
      <AnimatePresence>
        {isModalOpen && selectedVideo && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 z-50 flex items-center justify-center p-2 sm:p-4"
            onClick={closeModal}
          >
            {/* Backdrop */}
            <div className="absolute inset-0 bg-black/80 backdrop-blur-sm"></div>
            
            {/* Modal content */}
            <motion.div
              initial={{ scale: 0.9, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.9, opacity: 0 }}
              transition={{ type: "spring", damping: 25, stiffness: 300 }}
              className="relative w-full max-w-4xl aspect-video bg-black rounded-xl sm:rounded-2xl overflow-hidden shadow-2xl mx-2 sm:mx-4"
              onClick={(e) => e.stopPropagation()}
            >
              {/* Close button */}
              <button
                onClick={closeModal}
                className="absolute top-2 sm:top-4 right-2 sm:right-4 z-10 w-8 h-8 sm:w-10 sm:h-10 bg-black/50 hover:bg-black/70 rounded-full flex items-center justify-center transition-colors duration-200 group"
              >
                <svg 
                  className="w-4 h-4 sm:w-6 sm:h-6 text-white group-hover:text-gray-300 transition-colors duration-200" 
                  fill="none" 
                  stroke="currentColor" 
                  viewBox="0 0 24 24"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
              
                                            {/* Custom Video Player */}
                <video
                  src={selectedVideo}
                  className="w-full h-full"
                  controls
                  controlsList="nodownload noremoteplayback"
                >
                  Ваш браузер не поддерживает видео.
                </video>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </section>
  )
}

export default FamilyBusiness 